// Home page JS Here
function setUpHeroAnimation() {
  gsap.registerPlugin(ScrollTrigger);
  const mm = gsap.matchMedia();
  const beans = document.querySelectorAll(".beanLeft, .beanRight");
  const xlBreakPoint = 1280,
    lgBreakPoint = 1024,
    // mdBreakPoint = 768,
    smBreakPoint = 640,
    tallMobileW = 450,
    tallMobileH = 820;

  const bodyRect = document.body.getBoundingClientRect(),
    elem = document.getElementById("mainImg"),
    elemRect = elem.getBoundingClientRect(),
    offset = elemRect.top - bodyRect.top;

  const scale = {
    desktop: 1.35,
    laptop: 1.2,
    tablet: 1.3,
    mobile: 1.1,
    tallMobile: 1.1,
  };
  const imgPos = {
    desktop: "-30%",
    laptop: "-45%",
    tablet: "-10%",
    mobile: "-30%",
    tallMobile: "-25%",
  };
  const animStart = {
    desktop: "top 15%",
    laptop: "top 10%",
    tablet: "top 7.5%",
    mobile: "top 5%",
    tallMobile: "top 10%",
  };
  const animEnd = {
    desktop: "bottom 10%",
    laptop: "bottom 20%",
    tablet: "bottom 50%",
    mobile: "bottom top",
    tallMobile: "bottom top",
  };

  // add a media query. When it matches, the associated function will run
  mm.add(
    {
      // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
      isDesktop: `(min-width: ${xlBreakPoint}px)`,
      isLaptop: `(min-width: ${lgBreakPoint}px) and (max-width: ${
        xlBreakPoint - 1
      }px)`,
      isTablet: `(min-width: ${smBreakPoint}px) and (max-width: ${
        lgBreakPoint - 1
      }px)`,
      isMobile: `(max-width: ${smBreakPoint - 1}px)`,
      isTallMobile: `(max-width: ${tallMobileW}px) and (min-height: ${tallMobileH}px)`,
      reduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {
      const { isLaptop, isTablet, isMobile, isTallMobile, reduceMotion } =
        context.conditions;
      let device = "desktop";
      if (isTablet) {
        device = "tablet";
      } else if (isTallMobile) {
        device = "tallMobile";
      } else if (isMobile) {
        device = "mobile";
      } else if (isLaptop) {
        device = "laptop";
      }

      gsap.from(".slider-img", {
        scrollTrigger: {
          trigger: "#heroTop",
          scrub: 1,
          start: animStart[device],
          end: animEnd[device],
        },
        y: imgPos[device],
        scale: scale[device],
        transformOrigin: "center top",
        ease: "none",
      });

      ScrollTrigger.create({
        trigger: "#mainImg",
        start: "top 20%",
        end: "top 25%",
        onUpdate: (self) => {
          if (self.direction === 1) {
            gsap.to(".-leftIn", {
              autoAlpha: 1,
              x: 0,
              ease: "none",
              delay: 0.75,
              duration: reduceMotion ? 0 : 0.3,
            });
          } else {
            gsap.to(".-leftIn", {
              autoAlpha: 0,
              x: -20,
              ease: "none",
              duration: reduceMotion ? 0 : 0.3,
            });
          }
        },
      });

      ScrollTrigger.create({
        trigger: "#mainImg",
        start: "top 20%",
        end: "top 25%",
        onUpdate: (self) => {
          if (self.direction === 1) {
            gsap.to(".-rightIn", {
              autoAlpha: 1,
              x: 0,
              ease: "none",
              delay: 0.75,
              duration: reduceMotion ? 0 : 0.3,
            });
          } else {
            gsap.to(".-rightIn", {
              autoAlpha: 0,
              x: 20,
              ease: "none",
              duration: reduceMotion ? 0 : 0.3,
            });
          }
        },
      });

      gsap.to(".beanLeft", {
        scrollTrigger: {
          trigger: "#heroTop",
          scrub: 1.5,
          start: "top 10%",
          end: "bottom 10%",
          onLeave({ progress, isActive, direction }) {
            
            if (progress === 1) {
              setTimeout(() => {
                beans.forEach((bean) => bean.classList.add("opacity-0"));
              }, 750);
            }
          },
          onEnterBack({ progress, isActive, direction }) {
            
            if (isActive) {
              beans.forEach((bean) => bean.classList.remove("opacity-0"));
            }
          },
        },
        top: offset,
        left: "50%",
        rotate: 125,
        transformOrigin: "center top",
        ease: "none",
      });

      gsap.to(".beanRight", {
        scrollTrigger: {
          trigger: "#heroTop",
          scrub: 1.5,
          start: "top 10%",
          end: "bottom 10%",
        },
        top: offset,
        right: "50%",
        rotate: -125,
        transformOrigin: "center top",
        ease: "none",
      });
    }
  );

  gsap.to("#coffeeText", {
    scrollTrigger: {
      trigger: "#heroTop",
      scrub: 1,
      start: "top 10%",
      end: "bottom 10%",
    },
    y: "-200%",
    transformOrigin: "center top",
    ease: "none",
  });

  gsap.to("#byGreenDay", {
    scrollTrigger: {
      trigger: "#heroTop",
      scrub: true,
      start: "top 10%",
      end: "bottom 10%",
    },
    y: "-50%",
    transformOrigin: "center top",
    ease: "none",
  });

  gsap.to("#splashes", {
    scrollTrigger: {
      trigger: "#heroTop",
      scrub: 2,
      start: "top 10%",
      end: "bottom 10%",
    },
    y: "-100%",
    transformOrigin: "center top",
    ease: "none",
  });
}

if (document.readyState !== "loading") {
  setUpHeroAnimation();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    setUpHeroAnimation();
  });
}
